import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Card } from "@/components/ui";

import { SuperPageAssignmentsProgressRing } from "@/containers/SuperPages";
import { URLS } from "@/utils";

import pluralize from "pluralize";

type OwnProps = {
  completedCount: number;
  requestedCount: number;
};

type Props = OwnProps & RouteComponentProps;

const VideoPageAssignmentsQuickActionCardFC: React.FC<Props> = ({ completedCount, requestedCount, history }) => {
  const onCardClick = (): void => {
    history.push(`${URLS.player.superPages}?status=Requested`);
  };

  const subtitle = `You have ${pluralize("unfinished assignment", requestedCount, true)}`;

  const total = completedCount + requestedCount;
  const completionRate = total > 0 ? completedCount / total : 0;

  const getBorderColorClass = (rate: number): string => {
    if (rate >= 0.75) return "border-l-green-500";
    if (rate >= 0.35) return "border-l-amber-500";
    return "border-l-red-500";
  };

  const borderColorClass = getBorderColorClass(completionRate);

  return (
    <Card
      onClick={onCardClick}
      className={`w-full h-[120px] rounded-xl cursor-pointer transition-all duration-300 hover:shadow-md hover:scale-[1.015] active:scale-[0.99] flex flex-row items-center p-4 gap-4 border-l-4 ${borderColorClass}`}
    >
      {/* Text Column */}
      <div className="flex flex-col gap-1 min-w-0 flex-1 text-left select-none">
        <div className="text-base font-bold text-slate-800 leading-tight tracking-tight">Video Page Assignments</div>
        <p className="text-md text-slate-500 font-medium leading-normal line-clamp-3">{subtitle}</p>
      </div>

      {/* Circular Progress Ring Box on the Right */}
      <div className="rounded-full flex items-center justify-center shrink-0 shadow animate-in zoom-in-95 duration-200 select-none">
        <SuperPageAssignmentsProgressRing
          completedCount={completedCount}
          total={requestedCount + completedCount}
          size="sm"
          variant="compact"
        />
      </div>
    </Card>
  );
};

export const VideoPageAssignmentsQuickActionCard = withRouter(VideoPageAssignmentsQuickActionCardFC);
